"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDropzone = require("react-dropzone");
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Backup = _interopRequireDefault(require("@mui/icons-material/Backup"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Task = _interopRequireDefault(require("@mui/icons-material/Task"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("./styles");
var _FileStats = _interopRequireDefault(require("./FileStats"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SNETFileUpload = props => {
  const {
    disabled,
    minSize,
    maxSize,
    multiple,
    accept,
    onDrop,
    onDropAccepted,
    onDropRejected,
    showFileDetails,
    fileName,
    fileSize,
    fileDownloadURL,
    uploadSuccess,
    error,
    helperText,
    cleanCurrentFile
  } = props;
  const classes = (0, _styles.useStyles)();

  // eslint-disable-next-line no-unused-vars
  const {
    getRootProps,
    getInputProps
  } = (0, _reactDropzone.useDropzone)({
    disabled,
    minSize,
    maxSize,
    multiple,
    accept,
    onDrop,
    onDropAccepted,
    onDropRejected
  });
  const handleFileClean = e => {
    e.stopPropagation();
    cleanCurrentFile();
  };
  const fileUploaderColumnSize = showFileDetails ? 6 : 12;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement(_Grid.default, _extends({
    item: true,
    xs: 12,
    sm: 12,
    md: fileUploaderColumnSize,
    lg: fileUploaderColumnSize,
    className: classes.fileUploaderText
  }, getRootProps()), uploadSuccess ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cleanCurrentFile && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: classes.cleanButton,
    onClick: event => handleFileClean(event)
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)), /*#__PURE__*/_react.default.createElement(_Task.default, null), /*#__PURE__*/_react.default.createElement(_Typography.default, null, (0, _lodash.isArray)(fileName) ? fileName.map(name => " " + name) : fileName)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Backup.default, null), /*#__PURE__*/_react.default.createElement(_Typography.default, null, "Drag and drop image here or", /*#__PURE__*/_react.default.createElement("span", null, " click"))), helperText === null ? /*#__PURE__*/_react.default.createElement("p", null, "Click here to select one or more files, or drag and drop them over this text. Directory must be dragged. We expect", Object.values(accept).map(acceptTypes => acceptTypes.map(acceptType => " " + acceptType)), " ", "to be uploaded. Other files are disabled.") : helperText), showFileDetails && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6
  }, /*#__PURE__*/_react.default.createElement(_FileStats.default, {
    show: showFileDetails,
    fileName: fileName,
    fileSize: fileSize,
    fileDownloadURL: fileDownloadURL,
    uploadSuccess: uploadSuccess,
    error: error
  })));
};
SNETFileUpload.prototypes = {
  disabled: _propTypes.default.disabled,
  onFileSelect: _propTypes.default.func,
  minSize: _propTypes.default.number,
  maxSize: _propTypes.default.number,
  multiple: _propTypes.default.bool,
  accept: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  //https://github.com/react-dropzone/attr-accept
  onDrop: _propTypes.default.func,
  onDropAccepted: _propTypes.default.func,
  onDropRejected: _propTypes.default.func,
  showFileDetails: _propTypes.default.bool,
  fileName: _propTypes.default.string,
  fileSize: _propTypes.default.number,
  fileDownloadURL: _propTypes.default.string,
  uploadSuccess: _propTypes.default.bool,
  helperText: _propTypes.default.any
};
var _default = exports.default = SNETFileUpload;